var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41718 13.1814L9.02018 18.7654C9.58818 18.7654 9.83418 18.5214 10.1292 18.2284L12.7922 15.6834L18.3102 19.7244C19.3222 20.2884 20.0352 19.9914 20.3082 18.7934L23.9302 1.82141L23.9312 1.82041C24.2522 0.324405 23.3902 -0.260595 22.4042 0.106406L1.11418 8.25741C-0.338822 8.82141 -0.316822 9.63141 0.867178 9.99841L6.31018 11.6914L18.9532 3.78041C19.5482 3.38641 20.0892 3.60441 19.6442 3.99841L9.41718 13.1814Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b1e1a3e8.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41718 13.1814L9.02018 18.7654C9.58818 18.7654 9.83418 18.5214 10.1292 18.2284L12.7922 15.6834L18.3102 19.7244C19.3222 20.2884 20.0352 19.9914 20.3082 18.7934L23.9302 1.82141L23.9312 1.82041C24.2522 0.324405 23.3902 -0.260595 22.4042 0.106406L1.11418 8.25741C-0.338822 8.82141 -0.316822 9.63141 0.867178 9.99841L6.31018 11.6914L18.9532 3.78041C19.5482 3.38641 20.0892 3.60441 19.6442 3.99841L9.41718 13.1814Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b1e1a3e8.svg";
export { ForwardRef as ReactComponent };